// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3XJGp","open":"open___SG-_P","textEditor":"textEditor___2xiIC"};